function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useRef, useEffect, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Chart as ChartJS, LinearScale, CategoryScale, Title, Tooltip, Chart } from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import { alpha, getColorBlock, getPalette } from 'utils/ui/colors';
import { remToPx } from 'utils/ui';
import useBreakpoints from 'hooks/useBreakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
ChartJS.register(MatrixController, MatrixElement, LinearScale, CategoryScale, Title, Tooltip);
function Heatmap(_ref) {
  var useAlphaGradient = _ref.useAlphaGradient,
    data = _ref.data,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'chart' : _ref$color,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? false : _ref$animation,
    _ref$showLegend = _ref.showLegend,
    showLegend = _ref$showLegend === void 0 ? false : _ref$showLegend,
    nullLabel = _ref.nullLabel,
    xLabels = _ref.xLabels,
    yLabels = _ref.yLabels,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    onYLabelClick = _ref.onYLabelClick,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces;
  var suffix = max === 100 ? '%' : "/".concat(max);
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.s;
  var theme = useTheme();
  var chartColor = getColorBlock(color, theme);
  var textColor = theme.text;
  var linkColor = theme.links;
  var negativeColour = getColorBlock('heatmap-negative', theme);
  var neutralColour = getColorBlock('heatmap-neutral', theme);
  var positiveColour = getColorBlock('heatmap-positive', theme);
  var colorPalette = useMemo(function () {
    return useAlphaGradient ? [] : getPalette({
      startColor: negativeColour,
      midColor: neutralColour,
      endColor: positiveColour,
      length: 101
    });
  }, [negativeColour, neutralColour, positiveColour, useAlphaGradient]);
  var canvasRef = useRef(null);
  var chartRef = useRef(null);
  useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var chart = new Chart(ctx, {
      type: 'matrix',
      data: {
        datasets: [{
          label: label,
          data: data !== null && data !== void 0 ? data : [],
          backgroundColor: function backgroundColor(ctx) {
            var _ctx$raw4;
            if (useAlphaGradient) {
              var _ctx$raw, _ctx$raw2, _v, _ctx$raw3;
              return alpha(chartColor, (ctx === null || ctx === void 0 || (_ctx$raw = ctx.raw) === null || _ctx$raw === void 0 ? void 0 : _ctx$raw.v) !== null && (ctx === null || ctx === void 0 || (_ctx$raw2 = ctx.raw) === null || _ctx$raw2 === void 0 ? void 0 : _ctx$raw2.v) !== undefined ? ((_v = ctx === null || ctx === void 0 || (_ctx$raw3 = ctx.raw) === null || _ctx$raw3 === void 0 ? void 0 : _ctx$raw3.v) !== null && _v !== void 0 ? _v : 0) / max : 0);
            }
            var value = ctx === null || ctx === void 0 || (_ctx$raw4 = ctx.raw) === null || _ctx$raw4 === void 0 ? void 0 : _ctx$raw4.v;
            if (value === null || value === undefined) {
              return 'white';
            }
            var clampedValue = Math.max(0, Math.min(100, Math.round(value / max * 100)));
            return colorPalette[clampedValue];
          },
          width: function width(_ref2) {
            var _chart$chartArea;
            var chart = _ref2.chart;
            return ((_chart$chartArea = chart.chartArea) === null || _chart$chartArea === void 0 ? void 0 : _chart$chartArea.width) / xLabels.length - 1 || 20;
          },
          height: function height(_ref3) {
            var _chart$chartArea2;
            var chart = _ref3.chart;
            return ((_chart$chartArea2 = chart.chartArea) === null || _chart$chartArea2 === void 0 ? void 0 : _chart$chartArea2.height) / yLabels.length - 1 || 20;
          },
          borderRadius: theme.globals.borderRadius.small
        }]
      },
      options: {
        animation: animation,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: showLegend
          },
          tooltip: {
            titleColor: theme.background,
            titleFont: {
              weight: 'bold',
              size: remToPx(theme.globals.typeScale.s),
              family: 'Open Sans'
            },
            bodyColor: theme.background,
            bodyFont: {
              size: remToPx(theme.globals.typeScale.s),
              family: 'Open Sans'
            },
            backgroundColor: theme.text,
            borderWidth: 0,
            cornerRadius: theme.globals.borderRadius.small,
            callbacks: {
              label: function label(ctx) {
                var raw = ctx.raw;
                var value = raw.v === null ? nullLabel : "".concat(raw.v.toFixed(decimalPlaces)).concat(suffix);
                return "".concat(raw.y, ": ").concat(value);
              }
            }
          }
        },
        scales: {
          x: {
            type: 'category',
            labels: xLabels,
            offset: true,
            ticks: {
              autoSkip: false,
              color: textColor,
              font: {
                family: 'Open Sans'
              }
            },
            border: {
              color: chartColor
            },
            grid: {
              drawOnChartArea: false,
              color: chartColor
            }
          },
          y: {
            type: 'category',
            labels: yLabels,
            offset: true,
            border: {
              color: chartColor
            },
            grid: {
              drawOnChartArea: false,
              color: chartColor
            },
            ticks: {
              autoSkip: false,
              color: linkColor,
              font: {
                family: 'Open Sans',
                weight: 'bold',
                size: isDesktop ? remToPx(theme.globals.typeScale.s) : remToPx(theme.globals.typeScale.xxxs)
              }
            }
          }
        }
      }
    });
    chartRef.current = chart;

    // Click Handler for Y-axis labels
    var handleClick = function handleClick(event) {
      if (!chart || !onYLabelClick) return;
      var yScale = chart.scales.y;
      var clickY = event.offsetY;
      var pixelMargin = 6; // tolerance around the label
      var _iterator = _createForOfIteratorHelper(yScale.ticks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tick = _step.value;
          var pixel = yScale.getPixelForTick(tick.value);
          if (Math.abs(pixel - clickY) < pixelMargin) {
            if (typeof tick.label === 'string') {
              onYLabelClick(tick.label);
            }
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    // Hover handler for Y-axis labels
    var handleMouseMove = function handleMouseMove(event) {
      if (!chart) return;
      var yScale = chart.scales.y;
      var hoverY = event.offsetY;
      var pixelMargin = 6;
      var hovering = false;
      var _iterator2 = _createForOfIteratorHelper(yScale.ticks),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tick = _step2.value;
          var pixel = yScale.getPixelForTick(tick.value);
          if (Math.abs(pixel - hoverY) < pixelMargin) {
            hovering = true;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      canvas.style.cursor = hovering ? 'pointer' : 'default';
    };
    canvas.addEventListener('click', handleClick);
    canvas.addEventListener('mousemove', handleMouseMove);
    return function () {
      chart.destroy();
      canvas.removeEventListener('click', handleClick);
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [animation, color, data, theme, xLabels, yLabels, nullLabel, chartColor, textColor, label, linkColor, onYLabelClick, isDesktop, showLegend, useAlphaGradient, colorPalette, max, suffix, decimalPlaces]);
  return /*#__PURE__*/_jsx("canvas", {
    ref: canvasRef,
    role: "img",
    "aria-label": ariaLabel
  });
}
export default Heatmap;